import uniqueId from 'lodash/uniqueId'
import { StrictMode, useRef, VFC } from 'react'
import { Size } from '@opallabs/gem'
import {
  Button,
  ButtonIconPosition,
  ButtonSize,
  Icon,
  Tooltip,
} from '@opallabs/lapidary'
import { ControlProps } from './types'

export type { ControlProps }

export const Control: VFC<ControlProps> = ({
  description,
  disabled = false,
  displayLabel = false,
  glyph,
  onClick,
  pressed,
  theme = 'light',
}) => {
  const htmlId = useRef<string>(uniqueId('lapidary-viewheader-control'))

  const displayProps = displayLabel
    ? {
        buttonText: description,
        iconPosition: ButtonIconPosition.leading,
      }
    : { ariaLabelledBy: htmlId.current }

  const button = (
    <Button
      {...displayProps}
      ariaPressed={pressed}
      variant="ghost"
      disabled={disabled}
      hideButtonText={!displayLabel}
      icon={
        <Icon ariaHidden height={Size.Icon} glyph={glyph} width={Size.Icon} />
      }
      name={htmlId.current}
      onClick={onClick}
      size={ButtonSize.Small}
      theme={theme}
    />
  )

  if (displayLabel) return button

  return (
    <StrictMode>
      <Tooltip content={description} legacyTheme={theme}>
        {button}
      </Tooltip>
    </StrictMode>
  )
}
Control.displayName = 'Lapidary Unstable: Control ← ViewHeader'
